import { Spinner } from "@phosphor-icons/react";
import { useEDCFlow } from "@smvtech/x-flux";
import DocumentsList from "./components/VisaForm/DocumentsList";
import QuestionsList from "./components/VisaForm/QuestionsList";
import TravellerHeader from "./components/VisaForm/TravellerHeader";
import "./styles.scss";
import Header from "./components/Header";
import TncSubmit from "./components/TncSubmit";
import NoApplicant from "./components/NoApplicant";
import { useSearchParams } from "react-router-dom";
import ApplicationSubmitted from "./components/ApplicationSubmitted";
import useIsMobile from "./hooks/useIsMobile";
import MobileFlow from "./components/MobileFlow";
import AlreadySubmittedScreen from "./components/MobileFlow/AlreadySubmittedScreen";

const EDCFlow = () => {
	const [searchParams] = useSearchParams();
	const applicationId = searchParams.get("application_id");
	const { loading: isLoading, applicants, order } = useEDCFlow();
	const activeApplicantData = applicationId ? (applicants[applicationId] ?? null) : null;

	const isMobile = useIsMobile();

	if (isLoading) {
		return (
			<div className="flex min-h-screen items-center justify-center bg-[#F7F7F7]">
				<Spinner size={24} className="animate-spin text-primary-600" />
			</div>
		);
	}

	if (order?.internal_tags.includes("PAYMENT_PAID")) {
		return <ApplicationSubmitted />;
	}

	if (isMobile && order?.qc_terms_and_conditions) {
		return (
			<div className="min-h-screen bg-[#F7F7F7]">
				<AlreadySubmittedScreen travellerName={activeApplicantData?.traveller?.first_name} />
			</div>
		);
	}

	if (isMobile) {
		return (
			<div className="min-h-screen bg-[#F7F7F7]">
				<MobileFlow activeApplicantData={activeApplicantData} />
			</div>
		);
	}

	if (!activeApplicantData) {
		return <NoApplicant />;
	}

	return (
		<div className="min-h-screen bg-[#F7F7F7]">
			<div className="flex flex-col pt-6">
				<Header />

				<div className="pt-16 p-6 space-y-6">
					<div className="w-full h-full bg-white rounded-lg p-6">
						<div className="flex flex-col gap-4">
							<TravellerHeader activeApplicantData={activeApplicantData} />
							<div className="h-[1px] w-full bg-gray-200" />

							<div className="grid grid-cols-5 sm:px-4 md:gap-8 md:px-8 xl:gap-16 pt-4 pb-12">
								<DocumentsList activeApplicantData={activeApplicantData} />

								<QuestionsList activeApplicantData={activeApplicantData} />
							</div>
						</div>
					</div>

					<TncSubmit />
				</div>
			</div>
		</div>
	);
};

export default EDCFlow;

